/* ACM Vintage Wear — interacciones del tema (vanilla, sin librerías) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Revelado al hacer scroll ---------- */
  var observer = null;
  function initReveal(root) {
    var items = (root || document).querySelectorAll('.acm-reveal:not(.acm-visible)');
    if (!items.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('acm-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('acm-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    items.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- Formato de dinero ---------- */
  function euros(valor, decimales) {
    var d = typeof decimales === 'number' ? decimales : 2;
    try {
      return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR', minimumFractionDigits: d, maximumFractionDigits: d }).format(valor);
    } catch (e) {
      return valor.toFixed(d).replace('.', ',') + ' €';
    }
  }

  function animarNumero(el, destino, decimales) {
    var inicio = parseFloat(el.getAttribute('data-valor') || '0');
    el.setAttribute('data-valor', destino);
    if (reduceMotion) { el.textContent = euros(destino, decimales); return; }
    var t0 = null;
    var dur = 600;
    function paso(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / dur, 1);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = euros(inicio + (destino - inicio) * e, decimales);
      if (p < 1) requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);
  }

  /* ---------- Calculadora de beneficio ---------- */
  function initCalculadoras(root) {
    (root || document).querySelectorAll('[data-acm-calc]').forEach(function (calc) {
      if (calc.dataset.ready) return;
      calc.dataset.ready = '1';
      var botones = calc.querySelectorAll('.acm-calc__op');
      var rango = calc.querySelector('input[type=range]');
      var salida = calc.querySelector('output');
      var out = {
        coste: calc.querySelector('[data-out=coste]'),
        prendas: calc.querySelector('[data-out=prendas]'),
        porprenda: calc.querySelector('[data-out=porprenda]'),
        ingresos: calc.querySelector('[data-out=ingresos]'),
        beneficio: calc.querySelector('[data-out=beneficio]'),
        multi: calc.querySelector('[data-out=multi]')
      };
      var actual = calc.querySelector('.acm-calc__op[aria-pressed="true"]') || botones[0];

      function calcular() {
        if (!actual || !rango) return;
        var precio = parseFloat(actual.dataset.precio || '0');
        var prendas = parseInt(actual.dataset.prendas || '0', 10);
        var reventa = parseFloat(rango.value);
        var ingresos = prendas * reventa;
        var beneficio = ingresos - precio;
        if (salida) salida.textContent = reventa + ' €';
        if (out.coste) out.coste.textContent = euros(precio);
        if (out.prendas) out.prendas.textContent = '≈ ' + prendas;
        if (out.porprenda) out.porprenda.textContent = prendas > 0 ? euros(precio / prendas) : '—';
        if (out.ingresos) animarNumero(out.ingresos, ingresos, 0);
        if (out.beneficio) animarNumero(out.beneficio, beneficio, 0);
        if (out.multi) out.multi.textContent = precio > 0 ? 'x' + (ingresos / precio).toFixed(1).replace('.', ',') + ' tu inversión' : '';
      }

      botones.forEach(function (b) {
        b.addEventListener('click', function () {
          botones.forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          actual = b;
          calcular();
        });
      });
      if (rango) rango.addEventListener('input', calcular);
      calcular();
    });
  }

  /* ---------- Página de producto ---------- */
  function initProducto(root) {
    (root || document).querySelectorAll('[data-acm-pdp]').forEach(function (pdp) {
      if (pdp.dataset.ready) return;
      pdp.dataset.ready = '1';

      // Galería
      var principal = pdp.querySelector('.acm-pdp__main img');
      var thumbs = pdp.querySelectorAll('.acm-pdp__thumb');
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          if (!principal) return;
          principal.src = t.dataset.src;
          principal.srcset = '';
          principal.alt = t.dataset.alt || '';
          thumbs.forEach(function (o) { o.setAttribute('aria-current', 'false'); });
          t.setAttribute('aria-current', 'true');
        });
      });

      // Cantidad
      var qty = pdp.querySelector('.acm-qty input');
      pdp.querySelectorAll('.acm-qty button').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!qty) return;
          var v = parseInt(qty.value || '1', 10) + parseInt(b.dataset.step, 10);
          qty.value = Math.max(1, v);
        });
      });

      // Variantes
      var datos = pdp.querySelector('[data-acm-variantes]');
      var selects = pdp.querySelectorAll('[data-acm-opcion]');
      if (!datos || !selects.length) return;
      var variantes = [];
      try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
      var inputId = pdp.querySelector('input[name=id]');
      var precio = pdp.querySelector('[data-acm-precio]');
      var tachado = pdp.querySelector('[data-acm-tachado]');
      var boton = pdp.querySelector('[data-acm-add]');
      var textoBoton = boton ? boton.dataset.texto : '';
      var textoAgotado = boton ? boton.dataset.agotado : '';

      function actualizar() {
        var elegidas = Array.prototype.map.call(selects, function (s) { return s.value; });
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return o === elegidas[i]; });
        });
        if (!v) {
          if (boton) { boton.disabled = true; boton.querySelector('span').textContent = textoAgotado; }
          return;
        }
        if (inputId) inputId.value = v.id;
        if (precio) precio.textContent = euros(v.price / 100);
        if (tachado) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            tachado.textContent = euros(v.compare_at_price / 100);
            tachado.hidden = false;
          } else {
            tachado.hidden = true;
          }
        }
        if (boton) {
          boton.disabled = !v.available;
          boton.querySelector('span').textContent = v.available ? textoBoton : textoAgotado;
        }
        if (v.featured_image && principal) {
          principal.src = v.featured_image.src;
          principal.srcset = '';
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      selects.forEach(function (s) { s.addEventListener('change', actualizar); });
    });
  }

  function initAll(root) {
    initReveal(root);
    initCalculadoras(root);
    initProducto(root);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });

  // Editor de Shopify: re-inicializar al añadir/editar secciones
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
